import React, { useEffect, useRef, useState } from 'react'
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import Banner1 from '../assets/images/yarn.jpg';
import Inquiry from '../component/Contact';
import '../assets/css/about.css';

export default function Home() {
    const swiperRef1 = useRef();
    const [activeBox, setActiveBox] = useState(null);

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    const faqData = [
        {
            question: 'How does Rezude work?',
            answer: 'Rezude allows you to split your rent into two payments. We pay your full rent to your landlord on the due date, and you repay us in installments based on the payment schedule you choose—whether weekly, bi-weekly, or later in the month.',
            open: true,
        },
        {
            question: 'Is Rezude available for all properties?',
            answer: 'Rezude works with most rental properties, but availability may vary based on landlord participation.',
        },
        {
            question: 'Does Rezude affect my credit score?',
            answer: 'Yes, on-time payments may help improve your credit score as they can be reported to credit bureaus.',
        },
        {
            question: 'Are there any fees for using Rezude?',
            answer: 'Rezude may charge a small convenience fee depending on your payment schedule, which will be transparently shown.',
        },
        {
            question: 'What happens if I miss a payment?',
            answer: 'Missing a payment may impact your credit and could result in additional fees. It’s important to pay on time.',
        }
    ];

    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = index => {
        setActiveIndex(index === activeIndex ? null : index);
    };


    const [form, setForm] = useState({
        firstName: '', lastName: '', email: '', subject: '', message: ''
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = {};

        // Validate required fields
        Object.keys(form).forEach(field => {
            if (!form[field]) {
                newErrors[field] = 'This field is required';
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            alert('Form submitted successfully!');
            // Submit logic here
        }
    };

    const handleBoxClick = (index) => {
        setActiveBox(index === activeBox ? null : index); // toggle
    };


    const slides = [
        {
            title: "Global Logistics Excellence Powered by Triburg",
            subtitle: "From warehousing to last-mile delivery, Triburg ensures smooth, scalable logistics operations tailored to your industry needs.",
            image: require('../assets/images/slide-1.webp'),
        },
        {
            title: "Custom Packaging & Co-Packing Services Tailored to Your Needs",
            subtitle: "Triburg ensures every product is perfectly packed, labeled, and ready for market.",
            image: require('../assets/images/Packing-and.webp'),
        },
        {
            title: "Trusted Aviation Freight Across UAE and MENA",
            subtitle: "Supplying quality aviation Freight Services to airlines, airports, and private aviation companies.",
            image: require('../assets/images/slide-3.jpg'),
        },
    ];


    return (
        <>
            {/* Hero Banner Section */}
            <section className="hero-banner-section">
                <Swiper
                    modules={[Navigation, Autoplay, Pagination]}
                    spaceBetween={0}
                    slidesPerView={1}
                    navigation
                    pagination={{
                        clickable: true,
                        dynamicBullets: true
                    }}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    loop={true}
                    speed={1000}
                    className="hero-swiper"
                >
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className="hero-slide" style={{ backgroundImage: `url(${slide.image})` }}>
                                <div className="hero-overlay"></div>
                                <div className="hero-content-wrapper">
                                    <div className="container">
                                        <div className="hero-content">
                                            <div className="hero-text-box">
                                                <h1 className="hero-title">{slide.title}</h1>
                                                <div className="hero-divider"></div>
                                                <p className="hero-subtitle">{slide.subtitle}</p>
                                                <div className="hero-buttons">
                                                    <Link to="/services" className="hero-btn hero-btn-primary" style={{ textDecoration: 'none' }}>
                                                        Learn More
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>


            {/* About Us Section */}
            <section className='about-us-section' id="about">
                <div className='container-fluid p-0'>
                    <div className="row g-0 align-items-stretch">
                        {/* Left Content Section */}
                        <div className="col-lg-6 about-content-wrapper">
                            <div className="about-content">
                                {/* <div className="about-label mb-3">About Us</div> */}
                                <h1 className="hero-title text-sml mb-2">
                                    About Triburg Freight Services LLC
                                </h1>
                                <p className="hero-subtitle mb-4">
                                    At Triburg Freight Services LLC, logistics isn't just about moving boxes - it's about moving possibilities. For over 30 years, we've been at the heart of Dubai's thriving trade hub at Jebel Ali Free Zone, helping businesses streamline their supply chains with smart, reliable, and innovative solutions.
                                </p>
                                <p className="hero-subtitle mb-4">
                                    Born three decades ago, Triburg Freight Services LLC started with a simple mission: to make logistics smarter, faster, and more reliable. Today, we've evolved into a dynamic partner for brands and businesses, blending tradition with trend to deliver solutions that keep pace with the modern world.
                                </p>
                                <p className="hero-subtitle">
                                    We're more than a freight company. We're problem-solvers, brand-builders, and growth partners. From promo packaging that makes products shine, to customs clearance that cuts through red tape, to warehousing that keeps operations running smoothly — we deliver efficiency with a creative edge.
                                </p>

                                {/* Key Services */}

                            </div>

                        </div>

                        {/* Right Image Section */}
                        <div className="col-lg-6 about-image-wrapper">
                            <div className="about-image-overlay"></div>
                            <img
                                src={require('../assets/images/logistsic-about.jpg')}
                                alt="Triburg Logistics Operations"
                                className="about-main-image"
                            />
                            <div className="about-image-badge">
                                <div className="badge-content">
                                    <h2 className="badge-number">30+</h2>
                                    <p className="badge-text">Years of Excellence</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Promise Section */}
            <section className="our-promise-section" id="promise">
                <div className="container promise-container">
                    <div className="row align-items-center g-4">
                        {/* Left Content */}
                        <div className="col-lg-6">
                            <div className="promise-content">
                                <span className="promise-badge">
                                    <i className="fas fa-handshake promise-icon"></i> Our Promise
                                </span>
                                <h2 className="promise-title">
                                    Logistics Should Feel Effortless
                                </h2>
                                <p className="promise-description">
                                    At <strong>Triburg Freight Services LLC</strong>, we believe logistics should feel effortless. Whether you're a global enterprise or a growing startup, we tailor solutions that save time, reduce stress, and elevate your business.
                                </p>
                                <div className="promise-highlight-text">
                                    Because in today's fast-moving world, logistics isn't just about delivery - it's about experience, trust, and impact.
                                </div>
                                <p className="promise-description">
                                    And that's exactly what we've been perfecting for the last 30 years. Our commitment goes beyond moving goods; we move your business forward with innovation, reliability, and a personal touch that sets us apart.
                                </p>
                                {/* <div className="promise-years-badge">
                                    <span className="years-number">30</span>
                                    <span>Years of Excellence & Trust</span>
                                </div> */}
                            </div>
                        </div>

                        {/* Right Image */}
                        <div className="col-lg-6">
                            <div className="promise-image-wrapper">
                                <div className="promise-decorative-element top-left"></div>
                                <div className="promise-decorative-element bottom-right"></div>
                                <div className="promise-image-container">
                                    <img
                                        src={require('../assets/images/logistic-effect.jpg')}
                                        alt="Triburg Promise - Professional Logistics"
                                        className="promise-main-image"
                                    />
                                    <div className="promise-image-overlay"></div>
                                    <div className="promise-stats-overlay">
                                        <div className="promise-stat-item">
                                            <span className="promise-stat-number">1000+</span>
                                            <span className="promise-stat-label">Happy Clients</span>
                                        </div>
                                        <div className="promise-stat-item">
                                            <span className="promise-stat-number">24/7</span>
                                            <span className="promise-stat-label">Support</span>
                                        </div>
                                        <div className="promise-stat-item">
                                            <span className="promise-stat-number">100%</span>
                                            <span className="promise-stat-label">Satisfaction</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Confidence Section - Simple & Professional */}


            {/* Warehousing Section */}
            <section className="warehousing-section py-5" id="warehousing">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Image on Left */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="warehousing-image-wrapper">
                                <img
                                    src={require('../assets/images/warehouse.jpg')}
                                    alt="Modern Warehousing Facility"
                                    className="img-fluid rounded shadow-lg warehousing-main-image"
                                />
                                <div className="warehousing-badge">
                                    <div className="badge-icon">
                                        <i className="fas fa-warehouse"></i>
                                    </div>
                                    <div className="badge-text">
                                        <h4>30+</h4>
                                        <p>Years of Excellence</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content on Right */}
                        <div className="col-lg-6">
                            <div className="warehousing-content">
                                <div className="section-label mb-3">
                                    <i className="fas fa-box-open me-2"></i>
                                    <span className="text-uppercase fw-bold">Warehousing Solutions</span>
                                </div>
                                <h2 className="promise-title">
                                    Smart, Secure & Efficient Warehousing
                                </h2>

                                <p className="warehousing-description mb-4">
                                    At <strong>Triburg Freight Services LLC</strong>, warehousing is more than just storage - it's about creating a smart, secure, and efficient space that keeps your supply chain moving. With over 30 years of experience in Dubai's logistics industry, we've built warehousing solutions that combine reliability, innovation, and flexibility.
                                </p>
                                <p className="warehousing-description mb-4">
                                    In today's fast-paced world, warehousing isn't just about keeping products safe - it's about ensuring they're ready to move when you are. Whether you need short-term storage, long-term solutions, or specialized handling, Triburg Freight Services LLC delivers warehousing that adapts to your business needs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Warehousing Solutions Section */}
            <section className="our-warehousing-solutions-section py-5">
                <div className="container">
                    {/* Section Header */}
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <div className="solutions-header">
                                <span className="solutions-badge">
                                    <i className="fas fa-warehouse me-2"></i>
                                    Our Solutions
                                </span>
                                <h2 className="solutions-main-title mt-3">
                                    Our Warehousing Solutions
                                </h2>
                                <div className="title-underline mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    {/* Solutions Grid */}
                    <div className="row g-4">
                        {/* Strategic Locations */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-map-marker-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Strategic Locations</h3>
                                    <p className="solution-description">
                                        The facilities are positioned to give businesses easy access to Dubai's trade routes and global market.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Secure & Reliable */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-shield-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Secure & Reliable</h3>
                                    <p className="solution-description">
                                        Advanced safety systems and professional handling ensure your goods are protected at every stage.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Smart Inventory Management */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-boxes solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Smart Inventory Management</h3>
                                    <p className="solution-description">
                                        Organized storage and modern tracking methods help reduce costs and improve efficiency.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Seamless Integration */}
                        <div className="col-lg-6">
                            <div className="solution-card">
                                <div className="solution-icon-wrapper">
                                    <i className="fas fa-sync-alt solution-icon"></i>
                                </div>
                                <div className="solution-content">
                                    <h3 className="solution-title">Seamless Integration</h3>
                                    <p className="solution-description">
                                        Warehousing services are fully connected with our <b>transportation</b> and <b>customs clearance</b> operations, making end-to-end logistics effortless.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="confidence-section" id="confidence">
                <div className="container">
                    <div className="row align-items-center g-4">
                        {/* Left Image */}
                        <div className="col-lg-6">
                            <div className="confidence-image-wrapper">
                                <img
                                    src={require('../assets/images/why-choose-up.jpeg')}
                                    alt="Triburg Freight Services"
                                    className="confidence-main-image"
                                />
                            </div>
                        </div>

                        {/* Right Content */}
                        <div className="col-lg-6">
                            <div className="confidence-content">
                                <h2 className="confidence-title">
                                    We provide more than space — we provide confidence
                                </h2>
                                <p className="confidence-description">
                                    With Triburg Freight Services LLC, your products are always in the right place, at the right time, ready for the next step in your journey.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="why-choose-us-section" id="why-choose-us">
                <div className="container">
                    {/* Section Header */}
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <div className="why-choose-header">
                                <span className="why-choose-badge">
                                    <i className="fas fa-star me-2"></i>
                                    Why Choose Us
                                </span>
                                <h2 className="why-choose-main-title mt-3">
                                    Why Choose <span className="text-primary">Triburg</span>
                                </h2>
                                <div className="title-underline mx-auto"></div>
                            </div>
                        </div>
                    </div>

                    {/* Features Grid */}
                    <div className="row g-4 mb-5">
                        {/* Reliability */}
                        <div className="col-lg-3 col-md-6">
                            <div className="why-choose-card">
                                <div className="why-choose-icon-wrapper">
                                    <i className="fas fa-award why-choose-icon"></i>
                                </div>
                                <h3 className="why-choose-card-title">Reliability</h3>
                                <p className="why-choose-card-description">
                                    Three decades of proven performance in freight and logistics.
                                </p>
                            </div>
                        </div>

                        {/* Speed */}
                        <div className="col-lg-3 col-md-6">
                            <div className="why-choose-card">
                                <div className="why-choose-icon-wrapper">
                                    <i className="fas fa-shipping-fast why-choose-icon"></i>
                                </div>
                                <h3 className="why-choose-card-title">Speed</h3>
                                <p className="why-choose-card-description">
                                    Timely deliveries backed by advanced tracking systems.
                                </p>
                            </div>
                        </div>

                        {/* Flexibility */}
                        <div className="col-lg-3 col-md-6">
                            <div className="why-choose-card">
                                <div className="why-choose-icon-wrapper">
                                    <i className="fas fa-cogs why-choose-icon"></i>
                                </div>
                                <h3 className="why-choose-card-title">Flexibility</h3>
                                <p className="why-choose-card-description">
                                    Tailored solutions to fit every industry and cargo type.
                                </p>
                            </div>
                        </div>

                        {/* Global Network */}
                        <div className="col-lg-3 col-md-6">
                            <div className="why-choose-card">
                                <div className="why-choose-icon-wrapper">
                                    <i className="fas fa-globe why-choose-icon"></i>
                                </div>
                                <h3 className="why-choose-card-title">Global Network</h3>
                                <p className="why-choose-card-description">
                                    Strong partnerships and connections across continents.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Statement */}
                    <div className="row">
                        <div className="col-12">
                            <div className="why-choose-statement">
                                <h3 className="statement-title">
                                    Triburg Freight Services LLC is more than a logistics provider
                                </h3>
                                <p className="statement-description">
                                    We are your transportation partner, ensuring that every shipment moves smoothly, securely, and on time.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}
